/**
 * Created by eriksundqvist on 24/05/16.
 */
import * as types from './action-types';

export function setUserId (id) {
  return {
    type: types.SET_USER_ID,
    payload: id
  };
}

export function setTaxId (id) {
  return {
    type: types.SET_TAX_ID,
    payload: id
  };
}

export function setSaveVacationPay (bool) {
  return {
    type: types.SET_SAVE_VACATION_PAY,
    payload: bool
  };
}

export function setAmount (amount) {
  return {
    type: types.SET_AMOUNT,
    payload: amount
  };
}

export function setCustomerEntity (customerEntity) {
  return {
    type: types.SET_CUSTOMER_ENTITY,
    payload: customerEntity
  };
}

export function setCustomerId (customerId) {
  return {
    type: types.SET_CUSTOMER_ID,
    payload: customerId
  };
}

export function setCouponId (couponId) {
  return {
    type: types.SET_COUPON_ID,
    payload: couponId
  };
}

export function setCoupon (coupon) {
  return {
    type: types.SET_COUPON,
    payload: coupon
  };
}

export function clearCoupon () {
  return {
    type: types.CLEAR_COUPON
  };
}

export function setCurrencyId (currencyId) {
  return {
    type: types.SET_CURRENCY_ID,
    payload: currencyId
  };
}

export function setCurrencyName (currencyName) {
  return {
    type: types.SET_CURRENCY_NAME,
    payload: currencyName
  };
}

export function setCurrencyAmount (currencyAmount) {
  return {
    type: types.SET_CURRENCY_AMOUNT,
    payload: currencyAmount
  };
}

export function setSpecification (specification) {
  return {
    type: types.SET_SPECIFICATION,
    payload: specification
  };
}

export function setInvoiceDate (invoiceDate) {
  return {
    type: types.SET_INVOICEDATE,
    payload: invoiceDate
  };
}

export function setInvoiceUser (invoiceUser) {
  return {
    type: types.SET_INVOICEUSER,
    payload: invoiceUser
  };
}

export function setSendToEmail (email) {
  return {
    type: types.SET_SEND_TO_EMAIL,
    payload: email.trim()
  };
}

export function setSendToEmailSecondary (email) {
  return {
    type: types.SET_SEND_TO_EMAIL_SECONDARY,
    payload: email.trim()
  };
}

export function setSendToEmailBool (sendToEmailBool) {
  return {
    type: types.SET_SEND_TO_EMAIL_BOOL,
    payload: sendToEmailBool
  };
}

export function setCompanyPhone (companyPhone) {
  return {
    type: types.SET_COMPANY_PHONE,
    payload: companyPhone
  };
}

export function setEinvoiceAddress (einvoice) {
  return {
    type: types.SET_EINVOICE_ADDRESS,
    payload: einvoice.trim()
  };
}

export function setPoNumber (poNumber) {
  return {
    type: types.SET_PO_NUMBER,
    payload: poNumber.trim()
  };
}

export function setTaxKeyId (taxkeyId) {
  return {
    type: types.SET_TAX_KEY_ID,
    payload: taxkeyId
  };
}

export function setInvoiceId (invoiceId) {
  return {
    type: types.SET_INVOICE_ID,
    payload: invoiceId
  };
}

export function setExpressPayment (expressPayment) {
  return {
    type: types.SET_EXPRESS_PAYMENT,
    payload: expressPayment
  };
}

export function setSupplierLedger (supplierLedger) {
  return {
    type: types.SET_SUPPLIER_LEDGER,
    payload: supplierLedger
  };
}

export function setSubmitted (submitted) {
  return {
    type: types.SET_SUBMITTED,
    payload: submitted
  };
}

export function setValid (valid) {
  return {
    type: types.SET_VALID,
    payload: valid
  };
}

export function setPosting (posting) {
  return {
    type: types.SET_POSTING,
    payload: posting
  };
}

export function setPostError (postError) {
  return {
    type: types.SET_POST_ERROR,
    payload: postError
  };
}

export function setAmountIncVat (amountIncVat) {
  return {
    type: types.SET_AMOUNT_INC_VAT,
    payload: amountIncVat
  };
}

export function setLockAmountDistribution (lockAmountDistribution) {
  return {
    type: types.SET_LOCK_AMOUNT_DISTRIBUTION,
    payload: lockAmountDistribution
  };
}

export function setInitializing (initializing) {
  return {
    type: types.SET_INITIALIZING,
    payload: initializing
  };
}

export function setAmountAfterHsd (amountAfterHsd) {
  return {
    type: types.SET_AMOUNT_AFTER_HSD,
    payload: amountAfterHsd
  };
}

export function clear () {
  return {
    type: types.CLEAR
  };
}

export function setRot (rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) {
  return {
    type: types.SET_ROT,
    payload: {rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType}
  };
}

export function setRut (rut) {
  return {
    type: types.SET_RUT,
    payload: rut
  };
}

export function setManualInvoiceCalc (manualInvoiceCalc) {
  return {
    type: types.SET_MANUAL_INVOICE_CALC,
    payload: manualInvoiceCalc
  };
}

export function setDisplayDates (displayDates) {
  return {
    type: types.SET_DISPLAY_DATES,
    payload: displayDates
  };
}

export function setDisplayHours (displayHours) {
  return {
    type: types.SET_DISPLAY_HOURS,
    payload: displayHours
  };
}

export function setPreReport (preReport) {
  return {
    type: types.SET_PREREPORT,
    payload: preReport
  };
}

export function setPreReportedAt (preReportedAt) {
  return {
    type: types.SET_PREREPORTED_AT,
    payload: preReportedAt
  };
}

export function setTermsAccepted (termsAccepted) {
  return {
    type: types.SET_TERMSACCEPTED,
    payload: termsAccepted
  };
}

export function setLoggedInInvoiceUserTaxKeys (taxkeys) {
  return {
    type: types.SET_LOGGED_IN_INVOICE_USER_TAXKEYS,
    payload: taxkeys
  };
}

export function setLoggedInInvoiceUserTaxKeyId (taxkeyId) {
  return {
    type: types.SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID,
    payload: taxkeyId
  };
}

export function setMessageType (messageType) {
  return {
    type: types.SET_MESSAGE_TYPE,
    payload: messageType
  };
}

export function setSurveyAnswers (answers, status) {
  return {
    type: types.SET_SURVEY_ANSWERS,
    payload: {
      questions_and_answers: `[${answers}]`,
      status: status ? 'ok' : 'failed'
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/invoice/index.js
 **/